import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import classNames from 'classnames'
import { Field } from '@matillion/component-library'

import { useResetFieldOnProviderChange } from 'modules/FormsContent/CloudProviderCredentials/Fields/hooks'
import classes from 'modules/FormsContent/Form.module.scss'
import { FormValues } from 'modules/Projects/CloudProviderCredentials'

const AccessKeyID: FunctionComponent = () => {
  const {
    errors,
    handleBlur,
    handleChange,
    setFieldTouched,
    setFieldValue,
    touched,
    values
  } = useFormikContext<FormValues>()
  const { t } = useTranslation()
  useResetFieldOnProviderChange('accessKeyID', {
    setFieldTouched,
    setFieldValue
  })

  return (
    <div data-testid="cloud-provider-credentials-aws-access-key-id">
      <Field
        title={t('cloudProviderCredentials.fields.aws.accessKeyID.title')}
        name="accessKeyID"
        data-testid="cloud-provider-credentials-aws-access-key-id-input"
        value={values.accessKeyID}
        placeholder={t(
          'cloudProviderCredentials.fields.aws.accessKeyID.placeholderText'
        )}
        supportText={t(
          'cloudProviderCredentials.fields.aws.accessKeyID.supportText'
        )}
        onChange={handleChange}
        onBlur={handleBlur}
        className={classNames(classes.Form__Field)}
        errorText={
          errors?.accessKeyID && touched.accessKeyID
            ? t(errors.accessKeyID)
            : null
        }
        hasError={!!errors?.accessKeyID && touched.accessKeyID}
        required
      />
    </div>
  )
}

export default AccessKeyID
